import { PermissionString } from "../dtos.permissions";

/**
 * Contains function to check if a user has the required permission
 * PS stand for PermissionString -> Generic type of your AppPermissionString
 */
export const PERMISSION_SERVICE = "PermissionService";
export interface PermissionService<LoginData, PermissionContext, PS extends PermissionString = PermissionString> {

    /**
     * Check if a user as the given permission 
     * @param loginData data of the current logged-in user
     * @param permissions permission to check
     * @param permissionContext (optional) dictionary of key:entityType / value: entityUid
     * @returns True if has permission
     */
    hasPermission(loginData: LoginData, permissions: PS | PS[], permissionContext?: PermissionContext, matchAllPermission?: boolean): boolean;

}